import { IActiveSkill } from "../ISkill";
import { IArrowCaster } from "../IArrowCaster";

export default class ExplodingArrowSkill implements IActiveSkill {
  Name = "Exploding Arrow";
  Description = "Fire an arrow that explodes on impact, dealing area damage.";
  MaxLevel = 5;
  IconKey = "skill_exploding";
  KeyBinding = "THREE";

  ManaCost(level: number): number {
    return Math.max(20, 40 - level * 4);
  }

  CooldownMs(level: number): number {
    return Math.max(2000, 5000 - level * 600);
  }

  Execute(level: number, caster: IArrowCaster): boolean {
    const explosionRadius = 80 + level * 20;
    const explosionDmgMult = 0.2 + level * 0.05;
    caster.SpawnArrow({
      angle: caster.GetAimAngle(),
      damageMultiplier: 1.0 + explosionDmgMult,
      speedMultiplier: 1.0,
      isExploding: true,
      explosionRadius,
      explosionDmgMult,
    });
    return true;
  }
}
